import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useTrail } from './useTrail';

// Earlier crumbs give up width too, within a cap, so a long patient name
// never pushes the current crumb or the header's buttons out of view.
const ANCESTOR_CLASS = 'min-w-0 max-w-[12rem] truncate whitespace-nowrap';

/** Where you are, beside the sidebar toggle: the route's page, then the page's own crumbs. */
export const Breadcrumb: React.FC = () => {
  const crumbs = useTrail();
  if (crumbs.length === 0) return null;

  return (
    <nav
      aria-label='Breadcrumb'
      className='ml-3 flex min-w-0 items-center gap-1 text-sm text-muted-foreground'
    >
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        // Below `md` (the mobile shell) only the first and last crumbs fit
        // beside the header's buttons; the ones between show from `md` up.
        const middle = index > 0 && !isLast;
        return (
          <span
            key={`${index}-${crumb.label}`}
            className={`${middle ? 'hidden md:contents' : 'contents'}`}
          >
            {index > 0 && <ChevronRight className='h-3.5 w-3.5 shrink-0' />}
            {isLast ? (
              <span
                aria-current='page'
                className='min-w-0 truncate font-medium text-foreground'
              >
                {crumb.label}
              </span>
            ) : crumb.to ? (
              <Link
                to={crumb.to}
                title={crumb.label}
                className={`${ANCESTOR_CLASS} hover:text-foreground`}
              >
                {crumb.label}
              </Link>
            ) : (
              <span title={crumb.label} className={ANCESTOR_CLASS}>
                {crumb.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
};
